import React from 'react';

type SupplierEmptyStateProps = {
  icon?: string;
  title: string;
  message?: string;
  action?: React.ReactNode;
};

const SupplierEmptyState: React.FC<SupplierEmptyStateProps> = ({
  icon = 'fa-inbox',
  title,
  message,
  action,
}) => (
  <div className="sp-empty">
    <div className="sp-empty__icon" aria-hidden="true">
      <i className={`fa ${icon}`} />
    </div>
    <h3>{title}</h3>
    {message && <p>{message}</p>}
    {action && <div className="sp-empty__action">{action}</div>}
  </div>
);

export default SupplierEmptyState;
